export default{
    title:'Success!',
    text:'The action was completed successfully!',
    updated: 'The changes were saved successfully!',
    addedClient: 'Client was created successfully!',
    deleted: "Deletion was executed successfully!",
    syncStopped: 'Syncing stopped successfully!',
    foodRemoved: 'Food was removed successfully'
}
